import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Button,
    FormControl,
    FormLabel,
    Input,
    VStack,
    Heading,
    Text,
    Alert,
    AlertIcon,
    Spinner,
    useToast,
    InputGroup,
    InputRightElement,
    IconButton,
    Flex,
    Icon
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { FaBuilding } from "react-icons/fa";

const Login = () => {
    const { login } = useContext(AuthContext);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const toast = useToast();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            await login(email, password);
            toast({
                title: "Login Successful",
                description: "Welcome back!",
                status: "success",
                duration: 3000,
                isClosable: true
            });
            navigate("/");
        } catch (err) {
            setError("Invalid email or password");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Flex
            align="center"
            justify="center"
            minH="100vh"
            bg="linear-gradient(160deg, #F4F7FB 0%, #EAF2F8 55%, #DCEAF7 100%)"
            px={4}
        >
            <Box
                w={{ base: "100%", md: "400px" }}
                p={8}
                borderRadius="2xl"
                boxShadow="card"
                border="1px solid"
                borderColor="gray.100"
                bg="white"
                textAlign="center"
            >
                <Flex
                    align="center"
                    justify="center"
                    boxSize="52px"
                    mx="auto"
                    mb={4}
                    borderRadius="xl"
                    bg="brand.50"
                    color="brand.600"
                >
                    <Icon as={FaBuilding} boxSize={5} />
                </Flex>

                <Heading size="lg" color="brand.700" mb={1}>
                    Dobrodošli
                </Heading>
                <Text fontSize="sm" color="gray.500" mb={6}>
                    Prijavite se za nastavak
                </Text>

                {error && (
                    <Alert status="error" mb={4} borderRadius="xl">
                        <AlertIcon />
                        {error}
                    </Alert>
                )}

                <form onSubmit={handleSubmit}>
                    <VStack spacing={4} align="stretch">
                        <FormControl isRequired textAlign="left">
                            <FormLabel fontSize="sm" fontWeight="600" color="brand.700">
                                Email
                            </FormLabel>
                            <Input
                                type="email"
                                placeholder="Upišite email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                size="lg"
                                bg="surface.100"
                                border="1px solid"
                                borderColor="gray.200"
                            />
                        </FormControl>

                        <FormControl isRequired textAlign="left">
                            <FormLabel fontSize="sm" fontWeight="600" color="brand.700">
                                Lozinka
                            </FormLabel>
                            <InputGroup size="lg">
                                <Input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Upišite lozinku"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    bg="surface.100"
                                    border="1px solid"
                                    borderColor="gray.200"
                                />
                                <InputRightElement h="full">
                                    <IconButton
                                        size="sm"
                                        icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                                        onClick={() => setShowPassword(!showPassword)}
                                        variant="ghost"
                                        color="gray.400"
                                        aria-label={showPassword ? "Sakrij lozinku" : "Prikaži lozinku"}
                                    />
                                </InputRightElement>
                            </InputGroup>
                        </FormControl>

                        <Button
                            bg="brand.600"
                            color="white"
                            type="submit"
                            isLoading={loading}
                            w="100%"
                            size="lg"
                            mt={2}
                            boxShadow="0 8px 20px -8px rgba(21, 67, 96, 0.5)"
                            _hover={{ bg: "brand.700" }}
                            _active={{ bg: "brand.800" }}
                        >
                            {loading ? <Spinner size="sm" /> : "Prijava"}
                        </Button>
                    </VStack>
                </form>
            </Box>
        </Flex>
    );
};

export default Login;
